export const config = {
    "spacing": {
        "small": 4,
        "default": 8,
        "medium": 8,
        "large": 14,
        "extraLarge": 30,
        "padding": 16,
    },
    "separator": {
        "lineThickness": 1,
        "lineColor": "#33768893",
    },
    "supportsInteractivity": true,
    "fontTypes": {
        "default": {
            "fontFamily": "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            "fontSizes": {
                "small": 8,
                "default": 12,
                "medium": 14,
                "large": 18,
                "extraLarge": 20,
            },
            "fontWeights": {
                "lighter": 200,
                "default": 400,
                "bolder": 600,
            },
        },
        "monospace": {
            "fontFamily": "'Courier New', Courier, monospace",
            "fontSizes": {
                "small": 10,
                "default": 12,
                "medium": 16,
                "large": 20,
                "extraLarge": 24,
            },
            "fontWeights": {
                "lighter": 200,
                "default": 400,
                "bolder": 600,
            },
        },
    },
    "containerStyles": {
        "default": {
            "backgroundColor": "#FFFFFF",
            "foregroundColors": {
                "default": {
                    "default": "#1D1D1D",
                    "subtle": "#EE1D1D1D",
                },
                "accent": {
                    "default": "#4598F0",
                    "subtle": "#884598F0",
                },
                "attention": {
                    "default": "#E26735",
                    "subtle": "#DDE26735",
                },
                "good": {
                    "default": "#768893",
                    "subtle": "#33768893",
                },
                "warning": {
                    "default": "#F35959",
                    "subtle": "#DDF35959",
                },
            },
        },
        "emphasis": {
            "backgroundColor": "#08000000",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333",
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC",
                },
                "attention": {
                    "default": "#FF0000",
                    "subtle": "#DDFF0000",
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254",
                },
                "warning": {
                    "default": "#c3ab23",
                    "subtle": "#DDc3ab23",
                },
            },
        },
        "accent": {
            "backgroundColor": "#C7DEF9",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333",
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000",
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000",
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC",
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300",
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254",
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500",
                },
            },
        },
        "good": {
            "backgroundColor": "#CCFFCC",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333",
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000",
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000",
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC",
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300",
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254",
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500",
                },
            },
        },
        "attention": {
            "backgroundColor": "#FFC5B2",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333",
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000",
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000",
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC",
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300",
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254",
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500",
                },
            },
        },
        "warning": {
            "backgroundColor": "#FFE2B2",
            "foregroundColors": {
                "default": {
                    "default": "#333333",
                    "subtle": "#EE333333",
                },
                "dark": {
                    "default": "#000000",
                    "subtle": "#66000000",
                },
                "light": {
                    "default": "#FFFFFF",
                    "subtle": "#33000000",
                },
                "accent": {
                    "default": "#2E89FC",
                    "subtle": "#882E89FC",
                },
                "attention": {
                    "default": "#cc3300",
                    "subtle": "#DDcc3300",
                },
                "good": {
                    "default": "#54a254",
                    "subtle": "#DD54a254",
                },
                "warning": {
                    "default": "#e69500",
                    "subtle": "#DDe69500",
                },
            },
        },
    },
    "imageSizes": {
        "icon": 18,
        "default": 40,
        "small": 70,
        "medium": 80,
        "large": 160,
    },
    "actions": {
        "maxActions": 5,
        "spacing": "default",
        "buttonSpacing": 4,
        "showCard": {
            "actionMode": "inline",
            "inlineTopMargin": 16,
        },
        "actionsOrientation": "horizontal",
        "actionAlignment": "right",
    },
    "adaptiveCard": {
        "allowCustomStyle": false,
    },
    "imageSet": {
        "imageSize": "medium",
        "maxImageHeight": 100,
    },
    "factSet": {
        "title": {
            "color": "default",
            "size": "default",
            "isSubtle": false,
            "weight": "default",
            "wrap": true,
            "maxWidth": 150,
        },
        "value": {
            "color": "default",
            "size": "default",
            "isSubtle": false,
            "weight": "default",
            "wrap": true,
        },
        "spacing": 20,
    },
}
